import { render, staticRenderFns } from "./ChangelogDialog.vue?vue&type=template&id=2b9f00ba&scoped=true"
import script from "./ChangelogDialog.vue?vue&type=script&lang=js"
export * from "./ChangelogDialog.vue?vue&type=script&lang=js"
import style0 from "./ChangelogDialog.vue?vue&type=style&index=0&id=2b9f00ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9f00ba",
  null
  
)

export default component.exports